export default "__VITE_ASSET__77zk$epm__"